import { TextKey } from '@mews-commander/enums';
import { Link, Body } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { useLanguageCode } from '@mews-commander/core';
import { UnicodeEntity } from '@mews/enums';
import { LINK_ATTRS, MewsPaymentsLinksMap } from '../../constants';

export const MewsPaymentsInfo = () => {
    const languageCode = useLanguageCode();
    const languageCodeWithoutCountry = languageCode?.split('-')[0];

    const mewsPaymentsLink =
        typeof languageCodeWithoutCountry === 'string' && languageCodeWithoutCountry in MewsPaymentsLinksMap
            ? MewsPaymentsLinksMap[languageCodeWithoutCountry]
            : MewsPaymentsLinksMap.en;

    return (
        <Body>
            <LocalizedText textKey={TextKey.FinancialServicesCapitalNotOnMewsPayments} />
            {UnicodeEntity.NoBreakSpace}
            <Link href={mewsPaymentsLink} {...LINK_ATTRS} inherit>
                <LocalizedText textKey={TextKey.FinancialServicesCapitalGetMewsPayments} />
            </Link>
        </Body>
    );
};
